import { SwPush } from '@angular/service-worker';
import { AbstractServiceNotification } from './notification.service.abstract';
import { Observable, of } from 'rxjs';
import { AppConfig } from '../../app-services/config/config.app';
import { AppMonitoring } from '../../app-services/monitoring/monitor.app';
import * as Models from '../../../app/models/models';

export class MockServiceNotification implements AbstractServiceNotification {

    constructor(private appConfig: AppConfig,
        private swPush: SwPush, private appMonitoring: AppMonitoring) {
    }

    askForNotificationSubscription(organizationId: string, campaignId: string, notificationMessage: string): void {
        // Mock mode: never prompt for a real push subscription; just record the intent.
        this.appMonitoring.logEvent(this, 'Mock askForNotificationSubscription', {
            organizationId,
            campaignId,
            notificationMessage
        });
    }

    subscribeToNotifications(): void {
        this.appMonitoring.logEvent(this, 'Mock subscribeToNotifications');
    }

    sendNotifications(sendNotificationParameter: Models.NotificationConfiguration): Observable<Models.ResponseSendNotification> {
        this.appMonitoring.logEvent(this, 'Mock sendNotifications', { sendNotificationParameter });
        return of({ isSuccess: true });
    }
}
